import { useState } from "react";
import { TOKENS } from "@/constants/campaignBuilder";
import type { TokenEmail } from "@/interfaces/emailPreview";
import { TokenMenu } from "./TokenMenu";

export function TokenDropdown({
  onInsert,
  tokens = TOKENS,
}: {
  onInsert: (token: string) => void;
  /** The tag list to offer — pass `availableTokens(anonymousLinks)` to drop recipient-only tags. */
  tokens?: TokenEmail[];
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="font-lato text-[11px] font-semibold text-dark-dust hover:text-rodeo-black transition-colors"
        style={{ background: "none", border: "none", padding: 0, cursor: "pointer", marginLeft: 8 }}
      >
        Personalize with tags ▾
      </button>
      {open && (
        <>
          <button
            type="button"
            tabIndex={-1}
            className="fixed inset-0 z-10"
            onClick={() => setOpen(false)}
            onKeyDown={(e) => {
              if (e.key === "Escape") setOpen(false);
            }}
            aria-hidden="true"
            style={{ background: "transparent", border: "none", padding: 0, cursor: "default" }}
          />
          <TokenMenu
            items={tokens}
            onInsert={(t) => {
              onInsert(t.tag);
              setOpen(false);
            }}
            showHint
            className="absolute z-20"
            style={{ top: "calc(100% + 6px)", left: 0 }}
          />
        </>
      )}
    </div>
  );
}
